import { Suspense, lazy } from 'react';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppLoader from '@components/common/AppLoader';
import { ROUTES } from '@constants/routes';
import ProtectedRoutes from '@routes/ProtectedRoutes';
import PublicRoutes from '@routes/PublicRoutes';
import { useAuthStore } from '@store';

const NotFound = lazy(() => import('@pages/NotFound'));

function RootRedirect() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return <Navigate to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN} replace />;
}

function AppRouter() {
  return (
    <BrowserRouter>
      <Suspense fallback={<AppLoader fullHeight label="Loading application…" />}>
        <Routes>
          <Route path={ROUTES.ROOT} element={<RootRedirect />} />
          {PublicRoutes}
          {ProtectedRoutes}
          <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default AppRouter;
